import React, { useState, useContext } from 'react';
import TimelineView from './TimelineView/TimelineView';
import DatapointListView from './DatapointListView/DatapointListView';
import './style.css';
import { TestStatusContext } from '/src/App';
import { AddressSearchContext } from '/src/App';

const ChangeLog = ({ changeLog, menuSections }) => {
    const { testStatus } = useContext(TestStatusContext);

    // Get the portalData from the AddressSearchContext
    const { portalData } = useContext(AddressSearchContext);

    const [currentChangeLogView, setCurrentChangeLogView] = useState('timeline');
    const [currentTimelineStep, setCurrentTimelineStep] = useState(0);

    // Load the datapoints and projects from local storage
    const datapoints = portalData.datapoints || {};
    const projects = portalData.projects || {};
  

    // Process changeLog into datapoint-centric format
    const processChangeLogByDatapoint = () => {
        const dataPointTimelines = {};

        changeLog.forEach(entry => {
            // Process removed inputs
            Object.keys(entry.User_Inputs.removed).forEach(datapoint => {
                if (!dataPointTimelines[datapoint]) {
                    dataPointTimelines[datapoint] = {
                        datapoint_name: datapoint,
                        timeline: []
                    };
                }
                dataPointTimelines[datapoint].timeline.push({
                    time: entry.Timestamp,
                    updated_or_removed: 'removed',
                    updated_to: null
                });
            });

            // Process new inputs
            Object.keys(entry.User_Inputs.new).forEach(datapoint => {
                if (!dataPointTimelines[datapoint]) {
                    dataPointTimelines[datapoint] = {
                        datapoint_name: datapoint,
                        timeline: []
                    };
                }
                dataPointTimelines[datapoint].timeline.push({
                    time: entry.Timestamp,
                    updated_or_removed: 'updated',
                    updated_to: entry.User_Inputs.new[datapoint]
                });
            });
        });

        // Convert the object to array
        return Object.values(dataPointTimelines);
    };

    // Process changeLog for projects
    const processChangeLogByProject = () => {
        const projectTimelines = {};

        changeLog.forEach(entry => {
            // Process removed projects
            entry.Completed_Projects.removed.forEach(projectId => {
                if (!projectTimelines[projectId]) {
                    projectTimelines[projectId] = {
                        project_id: projectId,
                        timeline: []
                    };
                }
                projectTimelines[projectId].timeline.push({
                    time: entry.Timestamp,
                    added_or_removed: 'removed'
                });
            });

            // Process new projects
            entry.Completed_Projects.new.forEach(projectId => {
                if (!projectTimelines[projectId]) {
                    projectTimelines[projectId] = {
                        project_id: projectId,
                        timeline: []
                    };
                }
                projectTimelines[projectId].timeline.push({
                    time: entry.Timestamp,
                    added_or_removed: 'added'
                });
            });
        });

        return Object.values(projectTimelines);
    };

    const datapointTimelines = processChangeLogByDatapoint();
    const projectTimelines = processChangeLogByProject();
    const areThereChanges = datapointTimelines.length > 0 || projectTimelines.length > 0;
    console.log(areThereChanges)
    
    const VIEW_OPTIONS = [
        { label: 'View by Timeline', value: 'timeline' },
        { label: 'View by Datapoint', value: 'datapoint_list' }
    ];
    
    return (
        <div className="change-log-container">
            <div className="update-change-log-view-toggle-container">
                <div className="view-toggle">
                    {VIEW_OPTIONS.map(option => (
                        <button
                            key={option.value}
                            className={`update-data-change-log-toggle-button ${currentChangeLogView === option.value ? 'active' : ''}`}
                            onClick={() => setCurrentChangeLogView(option.value)}
                        >
                            {option.label}
                        </button>
                    ))}
                </div>
            </div>
            {areThereChanges ? (
                currentChangeLogView === 'timeline' ? (
                    <TimelineView
                        datapointTimelines={datapointTimelines}
                    projectTimelines={projectTimelines}
                    changeLog={changeLog}
                    datapoints={datapoints}
                    projects={projects}
                    menuSections={menuSections}
                />
            ) : (
                <DatapointListView
                    datapointTimelines={datapointTimelines}
                    projectTimelines={projectTimelines}
                    changeLog={changeLog}
                    datapoints={datapoints}
                    projects={projects}
                    menuSections={menuSections}
                />
                )
            ) : (
                <div className="no-changes-container">
                        <h2>No changes to show</h2>
                        {testStatus ? (
                            <p className="text-align-center">To make changes to your data and rerun this analysis you'll need to create an account.</p>
                        ) : (
                            <p className="text-align-center">To make changes to your data and rerun this analysis, simply make updates where applicable then click the "Update Analysis" button in the sidebar.</p>
                        )}
                </div>
            )}
        </div>
    );
}

export default ChangeLog;